import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {StaticDataService} from '../../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../../models/enum/enum-valid-value-item.model';
import {NotificationNeededDataModel} from '../../../../../models/messaging/noteToFront/notification-needed-data.model';
import {NotificationToFrontService} from '../../../../../services/messaging/notification-to-front.service';
import {Globals} from '../../../../../globals';
import {LettersSelectionDialogComponent} from '../../../../letters-selection-dialog/letters-selection-dialog.component';
import {ContactDataModel} from '../../../../../models/person/contact-data.model';
import {LetterTemplateDataModel} from '../../../../../models/letters/letter-template-data.model';
import {TdoTableRowModel} from '../../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {TdoTableSelectionEvent} from '../../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {NotificationNeededItemDataModel} from '../../../../../models/messaging/noteToFront/notification-needed-item-data.model';
import {LetterDeliveryToRoleEnum} from '../../../../../models/enum/letter-delivery-to-role.enum';
import {TdoTableV2Component} from '../../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {LettersService} from '../../../../../services/letters.service';
import {NotificationToFrontNeededItemContactModel} from '../models/notification-to-front-needed-item-contact.model';

@Component({
  selector: 'app-notification-to-front-items-needed-dialog',
  templateUrl: './notification-to-front-items-needed-dialog.component.html',
  styleUrls: ['./notification-to-front-items-needed-dialog.component.scss']
})
export class NotificationToFrontItemsNeededDialogComponent implements OnInit {
  @ViewChild('tdoTable') tdoTable: TdoTableV2Component;
  notificationNeededItemEnums: EnumValidValueItemModel[] = [];
  notificationNeededModel: NotificationNeededDataModel;
  selectedContacts: ContactDataModel[] = [];
  selectedTemplates: LetterTemplateDataModel[] = [];
  enumNotificationNeededItemJSON: string[] = [];

  // allTemplates: LetterTemplateDataModel[] = [];

  constructor(private dialogRef: MatDialogRef<NotificationToFrontItemsNeededDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: string,
              private globals: Globals,
              private notificationToFrontService: NotificationToFrontService,
              private staticDataService: StaticDataService,
              private lettersService: LettersService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
         this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.notificationNeededItemEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNotificationNeededItem');

    this.notificationToFrontService.getItemsNeeded(this.globals.currentPatientId, this.data).subscribe((res) => {
      if (!res.dataNotificationNeededItems) {
        res.dataNotificationNeededItems = [];
      } else {
        // Collect ToContactIds and types to query backend for them
        const persist: NotificationToFrontNeededItemContactModel[] = [];
        for (const item of res.dataNotificationNeededItems) {
          const model = new NotificationToFrontNeededItemContactModel();
          model.ToContactID = item.ToContactID;
          model.enumLetterDeliveryToRoleID = item.enumLetterDeliveryToRoleID;
          persist.push(model);
        }
        this.notificationToFrontService.getPersistentContactData(persist).subscribe((persRes) => {
          this.selectedContacts = persRes;
        });
      }

      this.notificationNeededModel = res;
      if (this.notificationNeededModel.enumNotificationNeededItemJSON) {
        this.enumNotificationNeededItemJSON = JSON.parse(this.notificationNeededModel.enumNotificationNeededItemJSON) as string[];
      } else {
        this.enumNotificationNeededItemJSON = [];
      }
      this.notificationNeededModel.CaseWorkItemId = this.data;
      // this.tdoTable.updateData(this.notificationNeededModel.dataNotificationNeededItems);
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.notificationToFrontService.saveNeeded(this.notificationNeededModel).subscribe((res) => {

    });

    this.dialogRef.close();
  }

  onAddLetterClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(LettersSelectionDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        if (res.neededItems) {
          for (const ni of res.neededItems) {
            if (!this.notificationNeededModel.dataNotificationNeededItems.includes(ni)) {
              this.notificationNeededModel.dataNotificationNeededItems.push(ni);
            }
          }
          if (res.selectedContacts) {
            for (const contact of res.selectedContacts) {
              if (!this.selectedContacts.includes(contact)) {
                this.selectedContacts.push(contact);
              }
            }
          }
          if (res.template) {
            if (!this.selectedTemplates.includes(res.template)) {
              this.selectedTemplates.push(res.template);
            }
          }
        }
        // If wasn't cancelled
        this.tdoTable.updateData(this.notificationNeededModel.dataNotificationNeededItems);
      }
    });
  }

  onNeededItemsChange(enu: EnumValidValueItemModel) {
    let items = this.enumNotificationNeededItemJSON;
    if (!items) {
      items = [];
    }
    if (!items.includes(enu.ValidValueItemId)) {
      items.push(enu.ValidValueItemId);
    } else {
      const idx = items.findIndex(p => p === enu.ValidValueItemId);
      if (idx > -1) {
        items.splice(idx, 1);
      }
    }

    this.notificationNeededModel.enumNotificationNeededItemJSON = JSON.stringify(this.enumNotificationNeededItemJSON);
  }

  getDeliveryRole(row: TdoTableSelectionEvent) {
    const model = row.model as NotificationNeededItemDataModel;
    switch (model.enumLetterDeliveryToRoleID) {
      case LetterDeliveryToRoleEnum.PATIENT:
        return 'Patient';
      case LetterDeliveryToRoleEnum.DOCTOR:
        return 'Doctor';
      case LetterDeliveryToRoleEnum.REFERRING_DOCTOR:
        return 'Referring';
      case LetterDeliveryToRoleEnum.GENERAL_DOCTOR:
        return 'General';
      case LetterDeliveryToRoleEnum.OTHER:
        return 'Other';
    }
  }

  getName(row: TdoTableSelectionEvent) {
    const model = row.model as NotificationNeededItemDataModel;
    const contact = this.selectedContacts.find(p => p.ContactId === model.ToContactID);
    if (contact) {
      return contact.FirstName + ' ' + contact.LastName;
    }

    return '';
  }

  getTemplateName(row: TdoTableSelectionEvent) {
    const model = row.model as NotificationNeededItemDataModel;
    const template = this.selectedTemplates.find(p => p.LetterTamplateID === model.ObjectID);
    if (template) {
      return template.LetterName;
    }

    return '';
  }

  getDate(row: TdoTableSelectionEvent) {
    const model = row.model as NotificationNeededItemDataModel;
    if (model.DeliveredOn) {
      return new Date(model.DeliveredOn).toDateString();
    }

    return ' / / ';
  }

  getDeliveryMethod(row: TdoTableSelectionEvent) {
    const model = row.model as NotificationNeededItemDataModel;
    // Currently we only do email
    /*switch (model.enumLetterDeliveryMethodID) {

    }*/

    return 'Email';
  }

  deleteNeededItem(row: TdoTableSelectionEvent) {
    const model = row.model as NotificationNeededItemDataModel;
    if (model.dataNotificationNeededItemID) {
      this.notificationToFrontService.deleteNeededItem(model).subscribe((res) => {
        //
      });
    }
    const idx = this.notificationNeededModel.dataNotificationNeededItems.findIndex(p => p.dataNotificationNeededItemID === model.dataNotificationNeededItemID);
    if (idx > -1) {
      this.notificationNeededModel.dataNotificationNeededItems.splice(idx, 1);
      this.tdoTable.updateData(this.notificationNeededModel.dataNotificationNeededItems);
    }
  }
}
